class RatingController {
  constructor() {
    this.bindEvents()
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const star = e.target.closest('[data-action="click->rating#rate"]')
      if (star) {
        e.preventDefault()
        e.stopPropagation()
        this.rate(star)
      }
    })
  }

  rate(starElement) {
    const container = starElement.closest('.rating-container')
    const score = starElement.dataset.score
    let versionId = container?.dataset?.versionId
    let conceptId = container?.dataset?.conceptId
    let ideaId = container?.dataset?.ideaId
    let blobId = container?.dataset?.blobId
    let photoFileId = container?.dataset?.photoFileId
    
    // Check if this is a photo file rating
    if (photoFileId) {
      const url = `/admin/photo_files/${photoFileId}/photo_file_ratings`
      this.postRating(url, container, score)
      return
    }
    
    // Check if this is an idea image rating
    if (ideaId && blobId) {
      const url = `/admin/ideas/${ideaId}/idea_image_ratings`
      this.postRating(url, container, score, { blob_id: blobId })
      return
    }
    
    if (!conceptId) {
      // Fallback: try from modal controller state
      const modalInst = window.ConceptModalControllerInstance
      if (modalInst && modalInst.currentConcept && modalInst.currentConcept.id) {
        conceptId = String(modalInst.currentConcept.id)
        // Also try to determine active version from the modal state
        const versions = modalInst.currentConcept.versions || []
        const idx = Number(modalInst.currentConcept.current_version_index || 0)
        if (!versionId && versions[idx]?.id) {
          versionId = String(versions[idx].id)
        }
      }
    }
    if (!conceptId) {
      conceptId = window.location.pathname.split('/')[3]
    }

    let url
    if (versionId) {
      url = `/admin/artwork_concepts/${conceptId}/artwork_versions/${versionId}/artwork_version_ratings`
    } else if (conceptId) {
      url = `/admin/artwork_concepts/${conceptId}/artwork_concept_ratings`
    } else {
      console.error('Rating container missing concept/version id')
      return
    }
    
    this.postRating(url, container, score)
  }
  
  postRating(url, container, score, extraData = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) {
      alert('CSRF token niet gevonden. Ververs de pagina.')
      return
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ score: parseInt(score), ...extraData })
    })
    .then(response => {
      if (!response.ok) {
        return response.text().then(text => {
          let errorMsg = `HTTP error! status: ${response.status}`
          try {
            const json = JSON.parse(text)
            if (json.error || json.message) {
              errorMsg = json.error || json.message
            }
          } catch (e) {
            if (text && text.length < 200) {
              errorMsg = text
            }
          }
          throw new Error(errorMsg)
        })
      }
      return response.json()
    })
    .then(data => {
      if (data.error) {
        alert('Fout: ' + data.error + (data.message ? ': ' + data.message : ''))
        return
      }
      
      if (!data.success && !data.user_rating) {
        alert('Onverwachte response van server')
        return
      }
      
      // Update UI
      const stars = container.querySelectorAll('.fa-star[data-score]')
      const rating = Number(data.user_rating)
      stars.forEach((star) => {
        const starScore = Number(star.dataset.score)
        // Reset classes
        star.classList.remove('fas', 'far', 'selected')
        if (starScore <= rating) {
          star.classList.add('fas', 'selected')
          star.style.color = '#ffc107'
        } else {
          star.classList.add('far')
          star.style.color = '#dddddd'
        }
      })
      
      // Update average rating display for photo files - only update stars, no text
      const photoFileId = container?.dataset?.photoFileId
      if (photoFileId) {
        // Remove any text elements after stars
        const starsContainer = container.querySelector('.photo-rating-stars')
        if (starsContainer) {
          const textSpan = starsContainer.querySelector('span')
          if (textSpan) {
            textSpan.remove()
          }
        }
      }
      
      // Update average rating display
      const scoreElement = container.querySelector('.score')
      if (scoreElement && data.average !== undefined && data.average !== null) {
        const average = Number(data.average) || 0
        const avgRounded = average.toFixed(1)
        scoreElement.textContent = isNaN(avgRounded) ? '' : String(avgRounded)
      }
      
      // Update average rating display for idea images (large layout)
      const ideaId = container?.dataset?.ideaId
      const blobId = container?.dataset?.blobId
      if (ideaId && blobId) {
        const averageRating = Number(data.average) || 0
        
        // Update data attribute on image wrapper
        const imageWrapper = document.querySelector(`.image-wrapper-large[data-blob-id="${blobId}"]`)
        if (imageWrapper) {
          imageWrapper.dataset.userScore = rating
          imageWrapper.dataset.averageRating = averageRating
        }
        
        // Update the average rating display in the large layout
        // The average rating div is a direct child of the rating-container, after the stars-container
        const starsContainer = container.querySelector('.stars-container')
        let averageRatingDiv = null
        
        // Look for existing average rating display (sibling of stars-container within rating-container)
        if (starsContainer && starsContainer.nextElementSibling) {
          const nextDiv = starsContainer.nextElementSibling
          // Check if it's the average rating div (has star icon or number)
          if (nextDiv.tagName === 'DIV' && 
              (nextDiv.querySelector('.fa-star') || nextDiv.textContent.match(/\d+\.?\d*/))) {
            averageRatingDiv = nextDiv
          }
        }
        
        // If not found, check all direct children of rating-container
        if (!averageRatingDiv) {
          container.querySelectorAll('div').forEach(div => {
            if (div !== starsContainer && 
                (div.querySelector('.fa-star') || div.textContent.match(/\d+\.?\d*/))) {
              averageRatingDiv = div
            }
          })
        }
        
        if (averageRating > 0 && !isNaN(averageRating)) {
          const avgText = averageRating.toFixed(1)
          if (averageRatingDiv) {
            // Update existing display - find the span with the number (not the one with "beoordelingen")
            const spans = averageRatingDiv.querySelectorAll('span')
            let scoreSpan = null
            spans.forEach(span => {
              if (!span.textContent.includes('beoordelingen') && span.textContent.match(/\d+\.?\d*/)) {
                scoreSpan = span
              }
            })
            
            if (scoreSpan) {
              scoreSpan.textContent = avgText
            } else {
              // Replace the entire content
              averageRatingDiv.innerHTML = `
                <i class="fas fa-star" style="color: #ffc107;"></i>
                <span>${avgText}</span>
                <span style="font-size: 12px; font-weight: normal; color: #666;">
                  (beoordelingen)
                </span>
              `
              averageRatingDiv.style.cssText = 'display: flex; align-items: center; gap: 6px; font-size: 16px; font-weight: 600; color: #333; justify-content: flex-start;'
            }
          } else {
            // Create new display if it doesn't exist
            const avgDiv = document.createElement('div')
            avgDiv.style.cssText = 'display: flex; align-items: center; gap: 6px; font-size: 16px; font-weight: 600; color: #333; justify-content: flex-start;'
            avgDiv.innerHTML = `
              <i class="fas fa-star" style="color: #ffc107;"></i>
              <span>${avgText}</span>
              <span style="font-size: 12px; font-weight: normal; color: #666;">
                (beoordelingen)
              </span>
            `
            // Insert after stars-container
            if (starsContainer && starsContainer.parentElement) {
              starsContainer.parentElement.insertBefore(avgDiv, starsContainer.nextSibling)
            } else {
              container.appendChild(avgDiv)
            }
          }
        } else if (averageRatingDiv) {
          // Remove display if rating is 0
          averageRatingDiv.remove()
        }
      }

      // Broadcast change so the zoom modal can keep its in-memory state in sync
      try {
        const conceptId = container?.dataset?.conceptId
        const versionId = container?.dataset?.versionId
        const ideaId = container?.dataset?.ideaId
        const blobId = container?.dataset?.blobId
        
        if (conceptId && versionId) {
          const evt = new CustomEvent('version-rating-updated', {
            detail: {
              conceptId: Number(conceptId),
              versionId: Number(versionId),
              user_rating: rating,
              average: Number(data.average)
            }
          })
          document.dispatchEvent(evt)
        }
        
        // Broadcast idea image rating update for sorting
        if (ideaId && blobId) {
          const evt = new CustomEvent('idea-image-rating-updated', {
            detail: {
              ideaId: Number(ideaId),
              blobId: Number(blobId),
              user_rating: rating,
              average: Number(data.average)
            }
          })
          document.dispatchEvent(evt)
        }
      } catch (e) {
        // no-op
      }
    })
    .catch(error => {
      console.error('Error rating:', error)
      console.error('Error details:', error.message, error.stack)
      alert('Er is een fout opgetreden bij het opslaan van je rating: ' + error.message)
    })
  }
}

// Initialize on both DOMContentLoaded and Turbo navigation events
function initRatingControllerOnce() {
  if (window.__ratingControllerInitialized) return
  window.__ratingControllerInitialized = true
  new RatingController()
}

document.addEventListener('DOMContentLoaded', initRatingControllerOnce)
document.addEventListener('turbo:load', initRatingControllerOnce)